import { NgTemplateOutlet } from '@angular/common';
import { Component, ContentChildren, ElementRef, QueryList, TemplateRef, viewChild, contentChild } from '@angular/core';

import { OptionComponent } from '@app-shared/components/autocomplete/option/option.component';
import { merge, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AutocompleteContentDirective } from './autocomplete-content.directive';

@Component({
  selector: 'app-autocomplete',
  template: `
    <ng-template #root>
      <div class="autocomplete" #autocompleteRef>
        <ng-container *ngTemplateOutlet="content().tpl" />
      </div>
    </ng-template>
  `,
  exportAs: 'appAutocomplete',
  styleUrls: ['./autocomplete.component.scss'],
  imports: [NgTemplateOutlet],
})
export class AutocompleteComponent {
  readonly rootTemplate = viewChild<TemplateRef<unknown>>('root');
  readonly autocompleteRef = viewChild<ElementRef>('autocompleteRef');

  readonly content = contentChild(AutocompleteContentDirective);

  @ContentChildren(OptionComponent)
  set options(options: QueryList<OptionComponent>) {
    this._options = options;
    setTimeout(() => {
      const autocompleteRef = this.autocompleteRef();
      if (autocompleteRef) {
        autocompleteRef.nativeElement.style.display = !options.length ? 'none' : 'block';
      }
    });
  }

  get options(): QueryList<OptionComponent> {
    return this._options;
  }

  private _options: QueryList<OptionComponent>;

  optionsClick(): Observable<unknown> {
    return this.options.changes.pipe(switchMap((options) => merge(...options.map((option) => option.click$))));
  }
}
